// src/actions/review-setting.js

import api from './gamba-api'
import config from '../config'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_SHOW_TIMESTAMP_SETTING = "FETCH_SHOW_TIMESTAMP_SETTING"
export const FETCH_SHOW_TIMESTAMP_SETTING_REQUESTED = "FETCH_SHOW_TIMESTAMP_SETTING_REQUESTED"
export const FETCH_SHOW_TIMESTAMP_SETTING_COMPLETED = "FETCH_SHOW_TIMESTAMP_SETTING_COMPLETED"
export const FETCH_SHOW_TIMESTAMP_SETTING_FAILED = "FETCH_SHOW_TIMESTAMP_SETTING_FAILED"

export function fetchShowTimestampSettingRequested() {
  return {
    type: FETCH_SHOW_TIMESTAMP_SETTING_REQUESTED
  }
}

export function fetchShowTimestampSetting() {
  return function(dispatch) {
    dispatch(fetchShowTimestampSettingRequested())
    return api.get(`/account/timestamp_setting`)
        .then((results)=> {
          dispatch(fetchShowTimestampSettingCompleted(results))
        })
        .catch((error)=> {
          console.log(error)
          Promise.all([
            dispatch(fetchShowTimestampSettingFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchShowTimestampSettingCompleted(results) {
  return {
    type: FETCH_SHOW_TIMESTAMP_SETTING_COMPLETED,
    results
  }
}

export function fetchShowTimestampSettingFailed(error) {
  return {
    type: FETCH_SHOW_TIMESTAMP_SETTING_FAILED,
    error,
  }
}


// WEBPACK FOOTER //
// ./src/actions/show-timestampe-setting.js